import { GOAL_APP_FEED_PATH, GOAL_FEED_PAGE, GOAL_FEED_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const goalUpdateViewRoute = createGlobalRoute({
	exact: true,
	name: GOAL_FEED_PAGE,
	path: GOAL_FEED_PATH,
	capabilities: ['goals_app:access'],
	layout: 'home',
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
});

export const goalsAppUpdateViewRoute = createGlobalRoute({
	exact: true,
	name: GOAL_FEED_PAGE,
	path: GOAL_APP_FEED_PATH,
	capabilities: ['goals_app:access'],
	layout: 'home',
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
});
